// @flow
import { useFirestore, useFirestoreCollectionData } from "reactfire";
import { ProfileTicketPersonRow } from "./ProfileTicket";
import React from "react";

function ProfileTicketCompanions({ userId, ticketReservation, paid }) {
  const firestore = useFirestore();
  const companionsRef = firestore
    .collection("users")
    .doc(userId)
    .collection("companions");
  const companions = useFirestoreCollectionData(companionsRef);

  return ticketReservation.companionIds.map((cid) => (
    <ProfileTicketPersonRow key={cid} name={companions.find((c) => c.id === cid).name} paid={paid} />
  ));
}

export default ProfileTicketCompanions;
